module.exports = __webpack_public_path__ + "static/img/14000601.c8db4268.png";